import { Component, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';
import StringEnum from '@shared/models/string-enum.model';

@Component({
  selector: 'app-form-item-enum',
  template: `
    <div [formGroup]="formGroup">
      <nz-form-item>
        <nz-form-label [nzFor]="controlName" [nzRequired]="isRequired">{{ label }}</nz-form-label>
        <nz-form-control>
          <nz-select [formControlName]="controlName" [nzShowSearch]="showSearch" nzPlaceHolder="Selecione uma opção">
            <nz-option *ngFor="let enum of enums" nzLabel="{{ enum.text }}" [nzValue]="enum.value"> </nz-option>
          </nz-select>
        </nz-form-control>
        <app-control-messages [control]="formGroup.controls[controlName]"></app-control-messages>
      </nz-form-item>
    </div>
  `,
})
export class FormItemEnumComponent {
  @Input() label: string;

  @Input() formGroup: FormGroup;

  @Input() controlName: string;

  @Input() enums: StringEnum[];

  @Input() isRequired = true;

  @Input() showSearch = false;

  constructor() {}
}
